import { render, staticRenderFns } from "./TariffPolicies.vue?vue&type=template&id=96769cb2&scoped=true&"
import script from "./TariffPolicies.vue?vue&type=script&lang=js&"
export * from "./TariffPolicies.vue?vue&type=script&lang=js&"
import style0 from "./TariffPolicies.vue?vue&type=style&index=0&id=96769cb2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96769cb2",
  null
  
)

export default component.exports